import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import { Container, Spacer, Section } from "@bw/bits"
import {
  Facebook,
  Instagram,
  Youtube,
  ArrowTop,
  Phone,
  Mepha,
} from "@bw/icons"
import styled from "styled-components"
import LayerMenu from "../header/LayerMenu"
import PropTypes from "prop-types"
import { breakpoints } from "../../../theme"
import Logo from "../header/logo"
import { useTranslation } from "react-i18next"

const EmergencyInfo = styled.div`
  font-size: 18px;
  line-height: 1.2;
  padding: 15px 0 15px 65px;
  position: relative;
  font-weight: 300;
  width: 100%;
  display: block;

  @media (min-width: ${breakpoints.medium}px) {
    padding: 15px 0 15px 95px;
  }
  &:last-child {
    &:after {
      display: none;
    }
  }

  &:after {
    border-bottom: 1px solid var(--light-grey);
    content: "";
    display: block;
    position: absolute;
    left: 65px;
    bottom: 0;
    right: 0;
    @media (min-width: ${breakpoints.medium}px) {
      left: 95px;
    }
  }
`

const StyledFooter = styled.div`
  padding: 45px 0 0 0;
  border-top: 1px solid var(--light-grey);
  font-size: 14px;
  position: relative;
  a {
    color: inherit;
    text-decoration: inherit;
  }
`

const End = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: end;

  grid-column: 1 / 3;

  @media (min-width: ${breakpoints.xsmall}px) {
    grid-column: unset;
  }

  @media (min-width: ${breakpoints.medium}px) {
    justify-content: space-between;
  }
`
const SocialMedias = styled.div`
  display: flex;
  justify-content: start;
  align-items: start;
  flex-direction: row;
  > * {
    margin: 0 9px 0 0;
  }

  @media (min-width: ${breakpoints.medium}px) {
    justify-content: start;
    flex-direction: row;
    align-items: start;
    margin-top: 0;
  }
`

const Emergencies = styled.button`
  cursor: pointer;
  border: 0;
  background: none;
  display: flex;
  padding: 0;
  opacity: 1;
  color: #000;
  transition: opacity 0.2s ease-in-out;
  font-weight: 300;
  align-items: center;
  &:hover {
    opacity: 0.5;
  }
  > * {
    margin-left: 5px;
  }

  @media (max-width: ${breakpoints.medium}px) {
    margin-bottom: 30px;
  }
`

const StyledLink = styled(Link)`
  display: flex;
  gap: 4px;
  opacity: 1;
  transition: opacity 0.2s ease-in-out;
  font-weight: 300;
  &:hover {
    opacity: 0.5;
  }
`

const SocialMedia = styled.div`
  padding: 8px;
  border-radius: 50%;
  background: var(--brand-brown);
  border: 2px solid var(--light-grey);
  transition:
    transform 0.3s ease-in-out,
    background 0.3s ease-in-out;

  &:hover {
    transform: scale(1.2);
    opacity: 1 !important;

    &.instagram {
      background: #d0126d;
      > * {
        fill: #fff;
      }
    }
    &.facebook {
      background: #2a528d;
    }
    &.youtube {
      background: #ae0d0d;
    }
    &.tiktok {
      background: rgb(255, 59, 92);
    }
    &.linkedin {
      background: #0a66c2;
    }
  }
`

const ScrollTop = styled.button`
  font-size: 14px;
  display: flex;
  border: none;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -65px;
  background: #fff;
  flex-direction: column;
  align-items: center;
  padding: 0 35px;
  cursor: pointer;
  color: #000;

  > :nth-child(2) {
    margin-top: 5px;
  }

  &:hover {
    > * {
      transition: transform 0.2s ease-in-out;
      transform: translateY(-4px);
    }
  }
`

const BottomFooter = styled.div`
  background: var(--lighter-grey);
  text-align: right;
  margin-top: 35px;
  padding: 30px 0px 75px;
  font-size: 12px;
`

const Copyright = styled.div`
  text-align: left;
  grid-column: 1/3;
`

const Grid = styled.div`
  display: grid;
  grid-gap: 15px 35px;

  grid-template-columns: 1fr 1fr;
  grid-template-rows: 200px 1fr;
  > :nth-child(3),
  > :nth-child(4) {
    align-items: start;
  }
  > :nth-child(1) {
    justify-self: start;
  }
  > :nth-child(2) {
    justify-self: center;
  }

  @media (min-width: ${breakpoints.medium + 130}px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr;
    grid-gap: 65px;
    > :nth-child(3),
    > :nth-child(4) {
      justify-self: end;
    }
    > :nth-child(2) {
      justify-self: start;
    }
  }
  > :nth-child(4) {
    justify-self: end;
  }
`

const LogoGrid = styled.div`
display: flex;
justify-content: center;
`
const StyledLogo = styled(Logo)`
  height: auto;
  width: 100%;
  display: block;
  max-width: 111px;
  @media (min-width: ${breakpoints.medium}px) {
    max-width: 197px;
  }
`

const LogoWrapper = styled.div`
  height: 86.8px;
  width: 111px;

  grid-column: 1 / 3;

  @media (min-width: ${breakpoints.xsmall}px) {
    grid-column: unset;
  }

  @media (min-width: ${breakpoints.medium}px) {
    width: 197px;
    height: 154.74px;
  }
`

const BottomFooterGrid = styled.div`
  flex-direction: reverse-column;
  display: grid;
  grid-gap: 30px 35px;
  grid-template-columns: 1fr 1fr;
  margin-top: 60px;
  > :nth-child(2) {
    justify-self: start;
  }
  > :nth-child(3) {
    justify-self: end;
  }

  @media (min-width: ${breakpoints.medium}px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    margin-top: 0px;
    > :nth-child(3),
    > :nth-child(2) {
      justify-self: end;
    }
  }

  @media (max-width: ${breakpoints.medium}px) {
    > :nth-child(1) {
      order: 3;
    }
  }

  > :nth-child(4) {
    justify-self: end;
  }
`
const Footer = ({ logos, copyright, menu }) => {
  const [show, setShow] = React.useState(false)
  const { t } = useTranslation()
  const pagesQuery = useStaticQuery(graphql`
    query PagesMenuQuery {
      privacyPolicy: globals(
        handle: { eq: "pages" }
        privacyPage: { ne: null }
      ) {
        id: privacyPage
      }
      terms: globals(handle: { eq: "pages" }, termsPage: { ne: null }) {
        id: termsPage
      }
      pages: allCollectionPages {
        nodes {
          statamicId
          slug
        }
      }
    }
  `)
  const { privacyPolicy, terms, pages } = pagesQuery
  const { privacyPolicySlug, termsSlug } = pages.nodes.reduce(
    (acc, item) => {
      if (item.statamicId === privacyPolicy.id[0]) {
        acc.privacyPolicySlug = item.slug
      }
      if (item.statamicId === terms.id[0]) {
        acc.termsSlug = item.slug
      }

      return acc
    },
    {
      privacyPolicySlug: null,
      termsSlug: null,
    }
  )

  return (
    <>
      <StyledFooter>
        <Section margin="0px 0px 70px 0px">
          <ScrollTop
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" })
            }}
          >
            <ArrowTop />
            <p>{t("footer.toTheTop")}</p>
          </ScrollTop>
          <Grid>
            <Spacer gap="small">
              {menu &&
                menu.length > 0 &&
                menu.slice(0, Math.floor(menu.length / 2)).map((node, i) => (
                  <StyledLink to={node.to} key={i}>
                    {node.label}
                  </StyledLink>
                ))}
            </Spacer>
            <Spacer gap="small">
              {menu &&
                menu.length > 0 &&
                menu.slice(Math.floor(menu.length / 2)).map((node, i) => (
                  <StyledLink to={node.to} key={i}>
                    {node.label}
                  </StyledLink>
                ))}
            </Spacer>
            <End>
              <Emergencies
                onClick={() => {
                  setShow(true)
                }}
              >
                {t("footer.urgence")}
                <Phone />
              </Emergencies>
              <SocialMedias>
                <a
                  href="https://www.instagram.com/pharmacieplus_ch/?hl=fr"
                  target="_blank"
                  rel="noreferrer"
                >
                  <SocialMedia className="instagram">
                    <Instagram fillColor="#fff" />
                  </SocialMedia>
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=100064748980805"
                  target="_blank"
                  rel="noreferrer"
                >
                  <SocialMedia className="facebook">
                    <Facebook fillColor="#fff" />
                  </SocialMedia>
                </a>
                <a
                  href="https://www.youtube.com/channel/UCH8EJo2ckOEcIqMpCXFZiWQ"
                  target="_blank"
                  rel="noreferrer"
                >
                  <SocialMedia className="youtube">
                    <Youtube fillColor="#fff" />
                  </SocialMedia>
                </a>
                <a
                  href="https://www.tiktok.com/@pharmacieplus_ch"
                  target="_blank"
                  rel="noreferrer"
                >
                  <SocialMedia className="tiktok">
                    <svg className="icon icon--small">
                      <use xlinkHref={`/sprite-v2.svg#tiktok`} />
                    </svg>
                  </SocialMedia>
                </a>
                <a
                  href="https://www.linkedin.com/company/1079819/admin/feed/posts/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <SocialMedia className="linkedin">
                    <svg className="icon icon--small">
                      <use xlinkHref={`/sprite-v2.svg#linkedin`} />
                    </svg>
                  </SocialMedia>
                </a>
              </SocialMedias>
            </End>
            <LogoWrapper>
              <StyledLogo height="100%" width="100%" />
            </LogoWrapper>
          </Grid>
        </Section>
        <BottomFooter>
          <Container>
            <Spacer>
              <BottomFooterGrid>
                <Copyright>
                  &copy;{copyright} {new Date().getFullYear()}
                </Copyright>
                {termsSlug && (
                  <Link to={termsSlug}>
                    {t("footer.conditionsUtilisation")}
                  </Link>
                )}
                {privacyPolicySlug && (
                  <Link to={privacyPolicySlug}>
                    {t("footer.politiqueConfidentialité")}
                  </Link>
                )}
              </BottomFooterGrid>
            </Spacer>
          </Container>
        </BottomFooter>
      </StyledFooter>
      <LayerMenu {...{ show, setShow }}>
        {[
          { title: "Police", phone: "117" },
          { title: "Feu - pompiers", phone: "118" },
          { title: "Urgences - ambulance", phone: "144" },
          { title: "Hélicoptère - REGA", phone: "1414" },
          { title: "Empoisonnement", phone: "145" },
          { title: "Urgences européennes", phone: "112" },
          { title: "Dépannage", phone: "140" },
          { title: "La Main Tendue", phone: "143" },
          { title: "Aide pour jeunes", phone: "147" },
        ].map(({ phone, title }) => (
          <EmergencyInfo key={phone}>
            <b>{title}</b>
            <br />
            {phone}
          </EmergencyInfo>
        ))}
      </LayerMenu>
    </>
  )
}

export { Footer }

Footer.propTypes = {
  logos: PropTypes.oneOf(["homepage", "standard"]),
  copyright: PropTypes.string,
}
Footer.defaultProps = {
  logos: "standard",
}
